var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fc21c27bc6864bdf2ea0aade1f00e03a5e91c879"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["codebycorey@codebycorey"]={id:"fc21c27bc6864bdf2ea0aade1f00e03a5e91c879"};
      